const types = {
    SET_REPLENISHMENT_REPORT: '[REPLENISHMENT REPORT] SET REPLENISHMENT GENERAL REPORT',
}

export {
    types
}